import React, { useEffect } from "react";
import { Pagination, PaginationItem, Stack } from "@mui/material";
import { useState } from "react";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

const PaginationDefault = ({ filters, updateFilter, totalCount, limit, offset, onHandlePageChange, resetPageOnOffsetZero = false }) => {
  const currentOffset = filters && filters.get("offset") ? filters.get("offset") : (offset ? offset : 0);
  const resultLimit = filters && filters.get("limit") ? filters.get("limit") : (limit ? limit : 25);
  const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
    if (resetPageOnOffsetZero && currentOffset === 0) {
      setCurrentPage(1);
    } else {
      setCurrentPage(Math.round(currentOffset / resultLimit) + 1);
    }
  }, [currentOffset, resultLimit, resetPageOnOffsetZero]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    if(updateFilter) {
      updateFilter("offset", (value - 1) * resultLimit);
    }
    if(onHandlePageChange) {
      onHandlePageChange(value - 1);
    }
  };
  return (
    totalCount && (
      <div className="flex justify-center flex-row">
        <div className={`flex justify-center py-2 md:px-0 px-0 w-full`}>
          <Stack alignItems={"center"}>
            <Pagination
              count={Math.ceil(totalCount / resultLimit)}
              onChange={handlePageChange}
              page={currentPage}
              renderItem={(item) => (
                <PaginationItem
                  slots={{
                    previous: ArrowBack,
                    next: ArrowForward,
                  }}
                  {...item}
                />
              )}
            />
          </Stack>
        </div>
      </div>
    )
  );
};
export default PaginationDefault;
